export default __webpack_public_path__ + "images/J9.ced77e1.png";